import { createContext, useContext, type PropsWithChildren } from 'react';

export const MODAL_LAYER_DEFAULT_Z_CLASS_NAME = 'z-[999]';
export const ABOVE_MODAL_LAYER_Z_CLASS_NAME = 'z-[1200]';

const ModalLayerContext = createContext(MODAL_LAYER_DEFAULT_Z_CLASS_NAME);

export const useModalLayerZClassName = () => useContext(ModalLayerContext);

export const ModalLayerProvider = ({
  zClassName,
  children,
}: PropsWithChildren<{ zClassName: string }>) => (
  <ModalLayerContext value={zClassName}>{children}</ModalLayerContext>
);
